import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Switch,
  Tooltip,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import { useStyles } from "./styles";

const CashDrawerSettings = ({ peripheral, updatePeripheralSettings }) => {
  const classes = useStyles();
  const [settings, setSettings] = useState({
    openOnCreditCardPayment: peripheral?.settings?.openOnCreditCardPayment ?? false,
    openOnZeroDiscount: peripheral?.settings?.openOnZeroDiscount ?? false,
    openOnSignOff: peripheral?.settings?.openOnSignOff ?? false,
  });

  const handleToggle = (key) => (event) => {
    const updatedSettings = {
      ...settings,
      [key]: event.target.checked,
    };
    setSettings(updatedSettings);
    updatePeripheralSettings(updatedSettings, peripheral?.peripheralID);
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item className={classes.settingRow}>
        <Tooltip arrow title="Opens the cash drawer when a credit card payment is completed successfully.">
          <FormControlLabel
            control={
              <Switch
                checked={settings.openOnCreditCardPayment}
                onChange={handleToggle("openOnCreditCardPayment")}
                color="primary"
                data-testid="openOnCreditCardPayment-switch"
              />
            }
            label={
              <Typography variant="body2">
                Open drawer on successful credit card payments
              </Typography>
            }
          />
        </Tooltip>
      </Grid>
      <Grid item className={classes.settingRow}>
        <Tooltip arrow title="Opens the cash drawer when validations reduce the total due to $0.00.">
          <FormControlLabel
            control={
              <Switch
                checked={settings.openOnZeroDiscount}
                onChange={handleToggle("openOnZeroDiscount")}
                color="primary"
                data-testid="openOnZeroDiscount-switch"
              />
            }
            label={
              <Typography variant="body2">
                Open drawer for transactions discounted to $0.00
              </Typography>
            }
          />
        </Tooltip>
      </Grid>
      <Grid item className={classes.settingRow}>
        <Tooltip arrow title="Opens the cash drawer when a cashier signs off.">
          <FormControlLabel
            control={
              <Switch
                checked={settings.openOnSignOff}
                onChange={handleToggle("openOnSignOff")}
                color="primary"
                data-testid="openOnSignOff-switch"
              />
            }
            label={
              <Typography variant="body2">
                Open drawer at sign-off
              </Typography>
            }
          />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default CashDrawerSettings;

CashDrawerSettings.propTypes = {
  peripheral: PropTypes.object,
  updatePeripheralSettings: PropTypes.func.isRequired,
};

CashDrawerSettings.defaultProps = {
  peripheral: {},
};
